import React from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import ServicesCards from '../components/ServicesCards';
import ReviewsSection from '../components/ReviewsSection';
import AreasSection from '../components/AreasSection';
import Footer from '../components/Footer';
import SEOHead from '../components/SEOHead';

const HomePage = () => {
  const { area } = useParams();
  const currentArea = area ? formatAreaName(area) : 'Aylesbury';

  // Dynamic SEO content based on area
  const pageTitle = `Diamond Cleaning ${currentArea} - Professional Domestic & Commercial Cleaning Services`;
  const pageDescription = `Professional cleaning services in ${currentArea} & surrounding areas. Domestic cleaning, commercial cleaning, end of tenancy, deep cleaning. Reliable, insured & vetted cleaners. Call 07878 522378`;
  const pageKeywords = `cleaning services ${currentArea}, domestic cleaning ${currentArea}, commercial cleaning ${currentArea}, end of tenancy cleaning ${currentArea}, deep cleaning ${currentArea}, office cleaning ${currentArea}, professional cleaners ${currentArea}, ${currentArea} cleaning company, insured cleaners, vetted cleaners`;

  // Enhanced structured data for home page
  const homePageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": pageTitle,
    "description": pageDescription,
    "url": `https://diamondcleaning-aylesbury.com${area ? `/home/${area}` : '/'}`,
    "mainEntity": {
      "@type": "LocalBusiness",
      "name": "Diamond Cleaning Aylesbury",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "5 Ossulbury Lane",
        "addressLocality": "Aylesbury",
        "addressRegion": "Buckinghamshire",
        "postalCode": "HP19 9DW",
        "addressCountry": "GB"
      },
      "telephone": "+447878522378",
      "email": "info@diamondcleaning-aylesbury.co.uk",
      "areaServed": currentArea,
      "serviceType": ["Domestic Cleaning", "Commercial Cleaning", "Deep Cleaning", "End of Tenancy Cleaning"]
    },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://diamondcleaning-aylesbury.com/"
        }
      ]
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOHead 
        title={pageTitle}
        description={pageDescription}
        keywords={pageKeywords}
        area={currentArea}
        schema={homePageSchema}
      />
      <Header currentArea={currentArea} />
      <HeroSection currentArea={currentArea} />
      <ServicesCards currentArea={currentArea} />
      <ReviewsSection currentArea={currentArea} />
      <AreasSection currentArea={currentArea} />
      <Footer />
    </div>
  );
};

const formatAreaName = (area) => {
  return area
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export default HomePage;